import React from 'react';
import type { E2eRunReportView } from '../../../services/e2e-runner/e2e-runner.service';
import classes from '../tenants-page.module.scss';

type E2eRunReportsProps = {
  tenantId: number;
  runs: E2eRunReportView[];
  isLoading: boolean;
  error: string | null;
};

const formatRunTitle = (run: E2eRunReportView): string => {
  const when = run.startedAt ? new Date(run.startedAt).toLocaleString('he-IL') : run.runId;
  const outcome = run.exitCode === 0 ? 'הצליחה' : run.exitCode === null ? 'בריצה' : 'נכשלה';
  return `${when} · ${run.tier ?? '—'} · ${run.branch ?? '—'} · ${outcome}`;
};

export const E2eRunReports: React.FC<E2eRunReportsProps> = ({ tenantId, runs, isLoading, error }) => {
  if (isLoading) {
    return (
      <span className={classes.e2eRunBranch} data-testid={`e2e-run-reports-loading-${tenantId}`}>
        טוען דוחות...
      </span>
    );
  }

  if (error) {
    return (
      <span className={classes.e2eRunError} data-testid={`e2e-run-reports-error-${tenantId}`}>
        {error}
      </span>
    );
  }

  return (
    <div className={classes.e2eRunReports} data-testid={`e2e-run-reports-${tenantId}`}>
      <span className={classes.e2eRunBranch}>צילומי מסך וסרטונים אינם נפתחים מהקישור — רק דוח ה-HTML</span>
      {runs.length === 0 && <span className={classes.e2eRunBranch}>אין ריצות שמורות</span>}
      {runs.map((run) => (
        <div key={run.runId} className={classes.e2eRunReportRow} data-testid={`e2e-run-report-${run.runId}`}>
          <span className={classes.e2eRunBranch}>{formatRunTitle(run)}</span>
          <div className={classes.e2eRunReportLinks}>
            {run.phases.map((phase, index) =>
              phase.reportUrl ? (
                <a
                  key={`${phase.name}-${phase.project ?? index}`}
                  className={classes.e2eRunReportLink}
                  href={phase.reportUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`e2e-run-report-link-${run.runId}-${phase.name}`}
                >
                  {`${phase.name}${phase.exitCode === 0 ? '' : ' ✗'}`}
                </a>
              ) : null,
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
